import { AbstractModel } from '.';

class model extends AbstractModel {
    endpoint = 'qr-code';
}

export const QrCodeModel = new model();
